/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrayFill: {
  name: 'array-fill';
  data: string;
} = {
  name: 'array-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 .5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V1A.5.5 0 0 0 3 .5H1Zm4 0a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5H5Zm7.5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
